import { Helmet } from "react-helmet";
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    FormHelperText,
    Container,
    Typography,
    Button
} from "@mui/material";
import arrow from "../../assets/images/arrow-right.svg";
import { ReactComponent as ProfileW } from "../../assets/images/profile/profile-w.svg";
import { ReactComponent as PasswordB } from "../../assets/images/profile/password-b.svg";
import { ReactComponent as SettingB } from "../../assets/images/profile/setting-b.svg";
import { ReactComponent as ExitB } from "../../assets/images/profile/exit-b.svg";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import SimpleDialog from "../../components/SimpleDialog";
import profileService from "../../services/profile.service";
import {
    NavLink as RouterLink,
    matchPath,
    useLocation,
    useNavigate,
    useParams
} from 'react-router-dom';
// import React, { useState, useEffect } from "react";
// import { color, maxWidth } from "@material-ui/system";
const useStyles = makeStyles({
    mainSetLang: {
        boxShadow: "none"
    },
    inputLang: {
        width: "100%",
        "& fieldset": {
            borderColor: "#979797",
        },
        "& .MuiSelect-select": {
            padding: "10px 0 9px 15px",
            color: "#4A877D"
        },
        "& .MuiMenuItem-root, .MuiOutlinedInput-root": {
            width: "100%",
            fontSize: "14px",
            lineHeight: "21px"
        }
    },
    menuItemActive: {
        backgroundColor: "#5DA196",
        color: "white"
    }
});
const styles = {
    container: {
        padding: "22px 25px 145px 24px",
    },
    title: {
        paddingBottom: "21px",
        borderBottom: "1px solid #E7E8E7",
        fontWeight: "500"
    },
    subTitle: {
        whiteSpace: "nowrap",
        paddingTop: "8px",
        marginRight: "44px"
    },
    boxSetLang: {
        paddingTop: "35px",
        display: "flex",
        flexFlow: "row",
    },
};

const SetLanguage = () => {
    const classes = useStyles();
    const [lang, setLang] = React.useState('th-TH');
    const navigate = useNavigate();

    const handleChange = (event) => {
        setLang(event.target.value);
    };
    const { t, i18n } = useTranslation();
    useEffect(() => {
        if (i18n.language !== undefined && i18n.language !== null && i18n.language !== "") {
            setLang(i18n.language)
        }
    }, []);
    const saveLang = async (event) => {
        i18n.changeLanguage(lang)
        localStorage.setItem("lang", lang);

        console.log('Set Lanuage', lang)

        try {
            const response = await profileService.updateUserLanguage(lang.split('-').shift())
        } catch (error) {
            console.log('Error updating user language', error)
        }


        // profileService.profile().then(
        //     (response) => {
        //         const name = response.data?.fullname?.split(" ")
        //         let user = JSON.parse(localStorage.getItem('user'))
        //         user.profile.firstname = name[0];
        //         user.profile.lastname = name[1];
        //         localStorage.setItem('user', JSON.stringify(user));
        //     },
        //   )
        openSuccessAddDialog(true)
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const onClose = (event) => {
        openSuccessAddDialog(false)
        // navigate('/app/profile', { replace: false });
    };
    return (
        <>
            <Box style={styles.container}>
                <Box>
                    <Typography fontSize={24} lineHeight="26.4px" style={styles.title}>{t(`label.changeLanguage`)}</Typography>
                </Box>
                <Box style={styles.boxSetLang}>
                    <Typography fontSize={18} lineHeight="24px" style={styles.subTitle}>{t(`label.systemLanguage`)}</Typography>
                    <FormControl sx={{ m: 1, minWidth: 120 }} class={classes.inputLang}>
                        <Select
                            value={lang}
                            onChange={handleChange}
                        // displayEmpty
                        // inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value="th-TH" ><span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>ไทย</span></MenuItem>
                            <MenuItem value="en-US" ><span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>English</span></MenuItem>
                        </Select>
                        {/* <FormHelperText>Without label</FormHelperText> */}
                    </FormControl>
                </Box>
            </Box>
            <Button onClick={saveLang} variant="contained" sx={{ position: "absolute", bottom: "56px", right: "25px", "font-size": "16px", "text-transform": "none" }}>
                {t(`label.save`)}
            </Button>
            <SimpleDialog
                open={isSuccessAddDialogOpen}
                setValue={onClose}
                text={t(`label.changeLanguageSuccess`)}
                subTitle="a"
            />
        </>
    );
};
export default SetLanguage;
